// extracted by mini-css-extract-plugin
module.exports = {"Footer":"SeeOtherCategories_Footer__29uiH"};